import { m } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Box, Link, Container, Typography, Stack, StackProps } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import TextIconLabel from '../../components/TextIconLabel';
import { MotionContainer, varFade } from '../../components/animate';
import useResponsive from '../../hooks/useResponsive';
import { FONT_TITLE } from 'src/theme/typography';

// ----------------------------------------------------------------------

const RootStyle = styled(m.div)(({ theme }: { theme: any }) => ({
  position: 'relative',
  backgroundColor: theme.palette.grey[400],
  [theme.breakpoints.up('md')]: {
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
  },
}));

const ContentStyle = styled((props: StackProps) => <Stack spacing={5} {...props} />)(
  ({ theme }: { theme: any }) => ({
    zIndex: 10,
    maxWidth: 520,
    margin: 'auto',
    textAlign: 'center',
    position: 'relative',
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
    [theme.breakpoints.up('md')]: {
      margin: 'unset',
      textAlign: 'left',
    },
  })
);

const HeroOverlayStyle = styled(m.img)({
  zIndex: 9,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

const HeroImgStyle = styled(m.img)(({ theme }: { theme: any }) => ({
  top: 90,
  right: 20,
  bottom: 0,
  zIndex: 8,
  width: '90%',
  margin: 'auto',
  position: 'absolute',
  [theme.breakpoints.up('lg')]: {
    right: '8%',
    width: 'auto',
    height: '48vh',
  },
}));

// const overlayImg = "https://res.cloudinary.com/dscrdg0ou/image/upload/v1746621730/NextGen/REGISTRATION_IS_OPEN_fjsa2c.webp"
// ----------------------------------------------------------------------

export default function HomeHero() {
  const isDesktop = useResponsive('up', 'md');

  return (
    <MotionContainer>
      <RootStyle>

          {isDesktop && <HeroOverlayStyle
          alt="overlay"
          src={"https://res.cloudinary.com/dscrdg0ou/image/upload/v1775052761/NextGen/2026/CoverMain2026_bu5kj9.webp"}
        />}

        {/* <HeroOverlayStyle
          alt="overlay"
          src={overlayImg}
        />

        <HeroImgStyle
          alt="hero"
          src="https://res.cloudinary.com/dscrdg0ou/image/upload/v1739718761/NextGen/Main_ipb5pc.webp"
        /> */}
        {!isDesktop && (
          <Container style={{ backgroundColor: 'white'}} sx={{ mt: 5 }}>
            <ContentStyle>
              <HeroImgStyle
                alt="hero"
                src="https://res.cloudinary.com/dscrdg0ou/image/upload/v1775050185/NextGen/2026/Cover2026_e3aed7.webp"
              />
              <m.div>
                <Typography variant="h1" sx={{ color: 'primary.main', fontFamily: FONT_TITLE }}>
                  {/* FROM GROANING TO GLORY */}
                </Typography>
              </m.div>

              <m.div>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    backgroundColor: 'rgba(255, 255, 255, 0.5);',
                  }}
                >
                  {/* KVBC NEXTGEN CONFERENCE 2023 <br />
                  26 AUG - 3 SEPT */}
                </Typography>
              </m.div>

              {/* <Stack spacing={2.5} alignItems="center" direction={{ xs: 'column', md: 'row' }}>
              <m.div variants={varFade().inUp}>
                <TextIconLabel
                  icon={
                    <Image
                      alt="sketch icon"
                      src="https://minimal-assets-api.vercel.app/assets/images/home/ic_sketch_small.svg"
                      sx={{ width: 20, height: 20, mr: 1 }}
                    />
                  }
                  value={
                    <Link
                      href="https://www.sketch.com/s/0fa4699d-a3ff-4cd5-a3a7-d851eb7e17f0"
                      target="_blank"
                      rel="noopener"
                      color="common.white"
                      sx={{ typography: 'body2' }}
                    >
                      Preview Sketch
                    </Link>
                  }
                />
              </m.div>

              <m.div variants={varFade().inUp}>
                <TextIconLabel
                  icon={
                    <Image
                      alt="sketch icon"
                      src="https://minimal-assets-api.vercel.app/assets/images/home/ic_figma_small.svg"
                      sx={{ width: 20, height: 20, mr: 1 }}
                    />
                  }
                  value={
                    <Link
                      href="https://www.figma.com/file/x7earqGD0VGFjFdk5v2DgZ/%5BPreview%5D-Minimal-Web?node-id=866%3A55474"
                      target="_blank"
                      rel="noopener"
                      color="common.white"
                      sx={{ typography: 'body2' }}
                    >
                      Preview Figma
                    </Link>
                  }
                />
              </m.div>
            </Stack> */}

              <m.div>
                {/* <Button size="large" variant="contained" component={RouterLink} to={'/'}>
                  Find Out More
                </Button> */}
              </m.div>

              {/* <Stack spacing={2.5}>
              <m.div variants={varFade().inUp}>
                <Typography variant="overline" sx={{ color: 'primary.light' }}>
                  Available For
                </Typography>
              </m.div>

              <Stack
                direction="row"
                spacing={1.5}
                justifyContent={{ xs: 'center', md: 'flex-start' }}
              >
                {['ic_sketch', 'ic_figma', 'ic_js', 'ic_ts', 'ic_nextjs'].map((resource) => (
                  <m.img
                    key={resource}
                    variants={varFade().inUp}
                    src={`https://minimal-assets-api.vercel.app/assets/images/home/${resource}.svg`}
                  />
                ))}
              </Stack>
            </Stack> */}
            </ContentStyle>
          </Container>
        )}
      </RootStyle>
      <Box sx={{ height: { md: '100vh' } }} />
    </MotionContainer>
  );
}
